import { jsx, jsxs } from "react/jsx-runtime";
import { mapLinkVariant } from "./constants.js";
import { StyledButtonReactLink, StyledButtonLink, StyledLink, StyledTypography, StyledIcon } from "./styles.js";
const Link = ({
  children,
  iconLeft,
  iconRight,
  color = "primary",
  href,
  size = "lg",
  disabled,
  onClick,
  to,
  sx,
  type,
  onCopy,
  onCopyCapture,
  ...props
}) => {
  const LinkBody = /* @__PURE__ */ jsxs(
    StyledTypography,
    {
      variant: mapLinkVariant[size],
      color,
      disabled,
      sx,
      children: [
        iconLeft && /* @__PURE__ */ jsx(StyledIcon, { size, children: iconLeft }),
        children,
        iconRight && /* @__PURE__ */ jsx(StyledIcon, { size, children: iconRight })
      ]
    }
  );
  return to ? /* @__PURE__ */ jsx(StyledButtonReactLink, { to, disabled, ...props, children: LinkBody }) : onClick ? /* @__PURE__ */ jsx(
    StyledButtonLink,
    {
      onClick,
      disabled,
      "data-test-id": props["data-test-id"],
      children: LinkBody
    }
  ) : /* @__PURE__ */ jsx(StyledLink, { href, disabled, ...props, children: LinkBody });
};
export {
  Link
};
//# sourceMappingURL=Link.js.map
